import React, { useEffect, useRef, useState } from 'react'

import Card from '@mui/material/Card'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import SendIcon from '@mui/icons-material/Send'

import { ChatItem } from '@/components/ui/chat/Chat'
import ChatBox from '@/components/ui/chat/ChatBox'
import ChatFeed from '@/components/ui/chat/ChatFeed'
import ChatInput from '@/components/ui/chat/ChatInput'

export type MessengerProps = {
  dataSource: ChatItem[]
  onSendMessage: (message: string) => void
  disableInput: boolean
}

export function Messenger(props: MessengerProps) {
  const { dataSource, onSendMessage, disableInput } = props

  const containerRef = useRef<HTMLDivElement>(null)

  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    if (containerRef.current) {
      const { top } = containerRef.current.getBoundingClientRect()
      if (window.innerHeight > top) containerRef.current.style.height = window.innerHeight - top - 20 + 'px' // 20px is padding bottom of page wrapper
      setMounted(true)
    }
  }, [])

  const handleSendMessage = (message: string) => {
    onSendMessage(message)
  }

  return (
    <Stack ref={containerRef} direction="row" justifyContent="center" alignItems="center" sx={{ minHeight: '400px' }}>
      {mounted && (
        <Card sx={{ width: '100%', height: '100%' }}>
          <ChatFeed>
            {dataSource.map((dataItem, index) => (
              <ChatBox key={`${dataItem.date} - ${index}`} {...dataItem} />
            ))}
          </ChatFeed>
          <Divider />
          {!disableInput && (
            <ChatInput
              onSendMessage={handleSendMessage}
              sendIcon={
                <IconButton>
                  <SendIcon />
                </IconButton>
              }
              sx={{
                p: '5px',
              }}
            />
          )}
        </Card>
      )}
    </Stack>
  )
}

export default Messenger
